import {CSSProperties, FC, HTMLAttributes} from "react";
import styles from './Typography.module.scss'
import {classNames} from "@shared/utils";

interface IProps extends HTMLAttributes<HTMLParagraphElement> {
    fontSize?: string
    fontCase?: 'normal' | 'upper' | 'lower'
    adaptiveFontSize?: number
    noWrap?: boolean
    fontWeight?: 'bold' | string
    align?: 'left' | 'right' | 'center' | string
    color?: string
    shadow?: boolean
    type?: 'span'
    scale?: number
}

export const Typography: FC<IProps> = (props) => {

    const {
        type = 'p',
        adaptiveFontSize = 0.6,
        children,
        fontWeight,
        noWrap,
        align,
        scale = 1,
        fontCase,
        ...typographyProps
    } = props;

    const TypographyElement = type

    const classNamesTypography = classNames(
        styles.root,
        {
            [styles.paragraph]: type === 'p',
            [styles[`font-case_${fontCase}`]]: !!fontCase,
        }
    )

    return (
        <TypographyElement
            className={classNamesTypography}
            style={{
                fontSize: `calc(${adaptiveFontSize}em + 1vmin)`,
                // fontSize: `clamp(0.4em, 0.5vw + ${scale}em, 1.2em)`,
                // fontSize: `calc((0.4em + 0.3vmin) + (0.4em + 0.3vmax))`,
                fontWeight: fontWeight ?? '',
                whiteSpace: noWrap ? 'nowrap' : 'pre-wrap',
                textAlign: align ?? 'inherit',
            } as CSSProperties}
            {...typographyProps}
        >
            {children}
        </TypographyElement>
    )
}